.large {
	height: 8px;
    width: 100%;
}

.small {
	height: 3px;

}

.gray > div {
    background-color: var(--hps-gray);
}

.blue > div {
    background-color: var(--hps-blue);

}

.darkgreen > div {
    background-color: var(--hps-dark-green);
}

.lightgreen > div {
    background-color: var(--hps-light-green);

}

.yellow > div {
    background-color: var(--hps-yellow);
}

.orange > div {
    background-color: var(--hps-orange);
}

.red > div {
    background-color: var(--hps-red);
}

.lightblue > div {
    background-color: var(--hps-light-blue);
}